const FALLBACK = "LAK";

/** ກີບບໍ່ໃຊ້ທົດສະນິຍົມໃນການສະແດງ (ບໍ່ແດ່ .00) */
function fractionDigitsForCurrency(code: string): { min: number; max: number } {
  if (code === "LAK") return { min: 0, max: 0 };
  return { min: 2, max: 2 };
}

/**
 * ສະແດງຍອດເງິນຕາມສະກຸນເງິນເອກະສານ (ISO 4217).
 */
export function formatDocumentCurrency(
  amount: number,
  currencyCode?: string | null,
): string {
  const code = (currencyCode?.trim() || FALLBACK).toUpperCase();
  const { min, max } = fractionDigitsForCurrency(code);
  try {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: code,
      minimumFractionDigits: min,
      maximumFractionDigits: max,
    }).format(amount);
  } catch {
    if (code === "LAK") {
      return `${Math.round(amount).toLocaleString("en-US")} ${code}`;
    }
    return `${amount.toFixed(2)} ${code}`;
  }
}
